var map = {
	"./attach.png": 21934,
	"./btn-camera.png": 87939,
	"./electricity.png": 94583,
	"./electricity2.png": 59271,
	"./product.png": 63756,
	"./product2.png": 34561,
	"./steaming.png": 67005,
	"./steaming2.png": 97917,
	"./water.png": 77767,
	"./water2.png": 15138
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91277;